<template>
  <scoped v-if="value">
    <TextInput
      v-model:value="value.unit"
      title="Unit"
      :readOnly="readOnly"
    />
    <NumberInput
      v-model:value="value.amount"
      title="Amount"
      :readOnly="readOnly"
    />
    <TextInput
      v-model:value="value.description"
      title="Description"
      :readOnly="readOnly"
      multiline
    />
    <NumberInput
      v-model:value="grossUnitPrice"
      title="Gross Unit Price"
      :readOnly="readOnly"
      @input="updateNetUnitPrice()"
    />
    <NumberInput
      v-model:value="netUnitPrice"
      title="Net Unit Price"
      :readOnly="readOnly"
      @input="updateGrossUnitPrice()"
    />
    <NumberInput
      v-model:value="value.vatRate"
      title="VAT Rate"
      :readOnly="readOnly"
      @input="updateGrossUnitPrice()"
    />
    <EnumerationPicker
      v-model:selection="value.discountType"
      :options="['FIXED', 'RATE', 'SUBTRACTION']"
      :readOnly="readOnly"
      title="Discount Type"
    />
    <NumberInput
      v-model:value="value.discountValue"
      title="Discount Value"
      :readOnly="readOnly"
    />
  </scoped>
</template>

<script setup lang="ts">
  import NumberInput from "@/components/inputs/number.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {computed, PropType} from "vue"
  import {OrderLine} from "@/endpoints/rutsolve/gql/generated/graphql"
  import EnumerationPicker from "@/components/selectors/enumeration.vue"

  defineProps({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  })

  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<OrderLine>
  })

  const grossUnitPrice = computed({
    get() {
      if (!value.value || !value.value.unitPrice) {
        return null
      } else {
        return value.value.unitPrice.gross
      }
    }, set(input: number) {
      if (!value.value || !value.value.unitPrice) {
        value.value.unitPrice = {}
      }
      value.value.unitPrice.gross = input
    }
  })

  const netUnitPrice = computed({
    get() {
      if (!value.value || !value.value.unitPrice) {
        return null
      } else {
        return value.value.unitPrice.net
      }
    }, set(input: number) {
      if (!value.value || !value.value.unitPrice) {
        value.value.unitPrice = {}
      }
      value.value.unitPrice.net = input
    }
  })

  function updateGrossUnitPrice() {
    if (!value.value.unitPrice || !value.value.unitPrice.net || value.value.unitPrice.net == 0) {
      value.value.unitPrice.gross = 0
      return
    }
    if (!value.value.vatRate || value.value.vatRate == 0) {
      value.value.unitPrice.gross = value.value.unitPrice.net
      return
    }
    const cent = 100
    const vatRatio = (value.value.vatRate + cent) / cent
    value.value.unitPrice.gross = value.value.unitPrice.net * vatRatio
  }

  function updateNetUnitPrice() {
    if (!value.value.unitPrice || !value.value.unitPrice.gross || value.value.unitPrice.gross == 0) {
      value.value.unitPrice.net = 0
      return
    }
    if (!value.value.vatRate || value.value.vatRate == 0) {
      value.value.unitPrice.net = value.value.unitPrice.gross
      return
    }
    const cent = 100
    const vatRatio = (value.value.vatRate + cent) / cent
    value.value.unitPrice.net = value.value.unitPrice.gross / vatRatio
  }
</script>
